import axios from 'axios'
import router from './router'

var http = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL
})

http.interceptors.response.use(null, function (error) {
    if (error.response) {
        if (error.response.status === 401) {
            router.push({ name: 'logout' })
        }
    }

    return Promise.reject(error);
});

export default http